export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 5.5a3 3 0 00-3 3V16a3 3 0 003 3h1.5v3a1 1 0 001 1h11a1 1 0 001-1v-3H20a3 3 0 002.996-2.846L23 16V8.5a3 3 0 00-3-3H4zM16.5 21h-9v-5.5h9V21zM20 7.5a1 1 0 011 1V16l-.005.102A1 1 0 0120 17h-1.5v-2.5a1 1 0 00-1-1h-11a1 1 0 00-1 1V17H4a1 1 0 01-1-1V8.5a1 1 0 011-1h16z\" fill=\"#7B61FF\"/><path d=\"M6.5 2v2h11V2h-11z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};